var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterDotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 3,
    viewBox: "0 0 4 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99728 2.292C1.80528 2.292 1.62528 2.248 1.45728 2.16C1.28928 2.064 1.15328 1.932 1.04928 1.764C0.953281 1.596 0.905281 1.404 0.905281 1.188C0.905281 0.98 0.953281 0.796 1.04928 0.636C1.15328 0.468 1.28928 0.336 1.45728 0.24C1.62528 0.144 1.80528 0.0959998 1.99728 0.0959998C2.19728 0.0959998 2.37728 0.144 2.53728 0.24C2.70528 0.336 2.83728 0.468 2.93328 0.636C3.02928 0.796 3.07728 0.98 3.07728 1.188C3.07728 1.404 3.02928 1.596 2.93328 1.764C2.83728 1.932 2.70528 2.064 2.53728 2.16C2.37728 2.248 2.19728 2.292 1.99728 2.292Z",
    fill: "#102975"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterDotIcon);
export default __webpack_public_path__ + "static/media/CenterDotIcon.e372bc8536ac4bdec15ad1af62e9d1ae.svg";
export { ForwardRef as ReactComponent };